<template>
    <div class="w-full">
        <Modal
            :show="show"
            :on-close-click="closeModal"
            :on-save-click="saveModal"
            modal-title="Vyber projekt"
            :show-footer="false"
            size="wide"
            :after-open="fetchProjects">
        
            <input type="text" ref="searchModalInput" class="rounded-full border border-gray-300 px-3 py-1 text-sm" placeholder="hľadať" v-model="search" @keyup="searchProjects">
        
            <div class="flex">
                <checkbox class="my-2" label-position="left" label="Zobraziť všetky" name="fixing"
                          :value="this.showAllProjects" @change="() => switchShowingProjects()"/>
                <checkbox class="my-2" label-position="left" label="Dokončené" name="fixing"
                          :value="this.showDoneProjects" @change="() => switchDoneProjects()"/>
            </div>
        
            <h6 class="font-bold text-xs mb-2 mt-4">Otvorené</h6>
        
            <transition-group name="fade" mode="out-in">
                <div v-for="project in mineProjects"
                     class="project-lister w-full rounded-full py-2 px-6 hover:shadow bg-gray-100 cursor-pointer flex items-center my-2 h-12"
                     :key="'p'+project.id"
                     v-ripple
                     @click="() => selectProject(project)">
                    <span class="text-sm w-32">{{ project.name }}</span>
                    <span class="avatars flex ml-4" v-if="project.members.length > 0">
                        <avatar v-for="member in project.members" :key="member.id" :member="member" class="border-gray-100"></avatar>
                    </span>
                    <span v-else class="ml-6 text-gray-600">Bez členov</span>
                    <span class="ml-auto text-xs font-bold">{{ formatTime(project.totalTime) }}</span>
                </div>
            </transition-group>
        </Modal>
    
    
        <div class="flex items-center shadow-md w-full h-16 bg-white">
            <div class="relative w-full">
                <label
                    for="projectNote"
                    class="project-note-label"
                    :class="labelPosition"
                    :style="{ transition: 'all 200ms ease' }"
                >{{ timerLabelText }}</label
                >
                <input
                    id="projectNote"
                    type="text"
                    class="project-note-input text-lg"
                    v-model="projectNote"
                    ref="projectNote"
                    @focusin="switchPositionIn"
                    @focusout="switchPositionOut"
                />
            </div>
            <div class="flex items-center justify-center w-3/4 md:w-1/2 mr-2 md:mr-4">
                <span class="ml-auto mr-3 text-gray-500" v-if="running" :title="formatDateTime(runningActivity.start_time, `[začiatok] DD.MM.YYYY [o] HH:mm:ss`)">{{ timer }}</span>
                <button v-ripple class="rounded bg-orange-500 text-white py-1 px-3 hover:shadow"
                        :class="running ? '' : 'ml-auto'"
                        @click="openModal">
                    <span v-if="!$isMobile">{{ !hasSelectedProject ? 'Vybrať projekt' : selectedProject.name }}</span>
                    <span v-if="$isMobile"><font-awesome icon="folder"></font-awesome></span>
                </button>
                <span class="dropdown bottom-right">
                    <span class="ml-4 text-xs text-gray-700"><font-awesome class="mr-1" icon="tag"></font-awesome> {{ this.selectedTag.name }}</span>
                    <span class="bg-white shadow z-max dropdown-menu">
                        <span class="dropdown-menu-item small cursor-pointer" v-ripple
                              v-for="tag in tags"
                              @click="() => selectTag(tag)"
                              :class="(selectedTag.id === tag.id) ? 'bg-orange-500 hover:bg-orange-400 text-white' : 'hover:text-gray-600'"
                        >{{ tag.name }}</span>
                    </span>
                </span>
                <checkbox class="mx-3" label-position="left" :label="$isMobile ? 'Opr.' : 'Oprava'" name="fixing"
                          v-model="fixing"/>
                <button class="text-white rounded-full w-12 h-12"
                        v-ripple
                        :disabled="!validateTimerStaring"
                        :style="$isMobile ? {bottom: '1.5rem', right: '1.5rem'} : {}"
                        :class="($isMobile ? 'fixed w-16 h-16 ' : '') + (running ? 'bg-red-500 hover:bg-red-600' : (!validateTimerStaring ? ($store.state.darkMode.enabled ? 'bg-green-800 cursor-default' : 'bg-green-200 cursor-default') :'bg-green-400 hover:bg-green-500'))"
                        @click="switchTimer">
                    <font-awesome class="fill-current fa-xs" :icon="running ? 'stop' : 'play'" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import {EventBus, formatTotal, getInicials, isIgnoredKey} from '../utils';
    import Checkbox from "./Checkbox";
    import Avatar from './Avatar';

    export default {
        name: "TimerControl",

        components: {Checkbox, Avatar},
        
        metaInfo() {
            return {
                title: this.running ? this.timer + " na " + this.selectedProject.name : "",
            }
        },

        data: () => {
            return {
                labelPosition: "",
                timerLabelText: "Na čom ideš pracovať?",
                show: false,

                projectNote: "",
                fixing: false,
                showAllProjects: true,
                showDoneProjects: false,
                selectedProject: {},
                search: "",
                searchTimer: null,
                timer: "00:00:00",
                selectedTag: {}
            };
        },
        
        beforeMount() {
            EventBus.$on('userFetched', () => {
                this.fetchJobs()
            });
            
            this.fetchJobs();
            
            this.$store.dispatch("fetchTags").then(() => this.selectTag());

            EventBus.$on("runTimer", (project, note) => {
                this.selectedProject = project;
                this.projectNote = note;
                this.switchPositionIn();
                this.enableTimerTick();
            })
        },
        
        computed: {
            ...mapState({
                user: state => state.account.user,
                mineProjects: state => state.timer.mineProjects,
                running: state => state.timer.running,
                runningActivity: state => state.timer.runningActivity,
                tags: state => state.tags.all
            }),

            validateTimerStaring() { return this.projectNote.length >= 2 && Object.keys(this.selectedProject).length > 0; },

            hasSelectedProject() { return Object.keys(this.selectedProject).length > 0; },
        },
        
        methods: {

            formatDateTime(date, format) {
                return moment(date).utc(true).format(format)
            },

            selectTag(tag = null) {
                for(let tt of this.tags) {
                    // select default selected, else select this one witch is given
                    if(tag === null) {
                        if(tt.selected) {
                            this.selectedTag = tt;
                            break;
                        }
                    }else if(tt.id === tag.id) {
                        this.selectedTag = tt;
                        break;
                    }
                }
            },
            
            fetchJobs () {
                if (this.user.has_running_job) {
                    this.labelPosition = 'focused';
                    this.$store.dispatch('fetchRunningActivity').then(() => {
                        this.selectedProject = this.runningActivity.project;
                        this.projectNote = this.runningActivity.note;
                        this.fixing = this.runningActivity.fixing;
                        this.$store.commit('setRunning', true);
                        this.selectTag(this.runningActivity.tag);

                        this.enableTimerTick()
                    }).catch((e) => {
                        console.log(e)
                    });
                }
            },

            switchTimer() {
                if (this.running) {
                    this.$store.dispatch('stopActivity', {
                        note: this.projectNote
                    }).then(() => {
                        this.selectedProject = {};
                        this.projectNote = '';
                        this.fixing = false;
                        this.labelPosition = "";
                        this.$store.dispatch('fetchLatestActivity', {daysBack: 5});
                        this.disableTimerTick()
                    })
                } else {
                    this.$store.dispatch('startActivity', {
                        selectedProject: this.selectedProject,
                        note: this.projectNote,
                        fixing: this.fixing,
                        tag_id: this.selectedTag.id
                    }).then(() => {
                        this.$store.dispatch('fetchRunningActivity').then(() => {
                            this.enableTimerTick()
                        })
                    })
                }
            },

            tick () {
                let now = moment.utc(new Date());
                let startTime = moment.utc(this.runningActivity.start_time).local(false);
                let diff = now.diff(startTime, 'seconds');
                let duration = moment.duration(diff, 'seconds');
                let hrs = duration.hours();
                let mins = duration.minutes();
                let secs = duration.seconds();

                if (hrs < 10) { hrs = '0' + hrs }
                if (mins < 10) { mins = '0' + mins }
                if (secs < 10) { secs = '0' + secs }
                
                this.timer = `${hrs}:${mins}:${secs}`;
            },

            enableTimerTick () {
                this.timerLabelText = 'Pracuješ na';
                this.tick();
                this.timerInterval = setInterval(() => {
                    this.tick()
                }, 1000)
            },

            disableTimerTick () {
                clearInterval(this.timerInterval);
                this.timer = '00:00:00';
                this.timerLabelText = 'Na čom ideš pracovať?';
                this.selectTag();
                this.switchPositionOut();
            },

            searchProjects(e) {
                clearTimeout(this.searchTimer);
                
                if(isIgnoredKey(e.key) || e.ctrlKey) {
                    return;
                }
                
                this.searchTimer = setTimeout(() => this.fetchProjects(), 600)
            },

            switchShowingProjects() {
                this.showAllProjects = !this.showAllProjects;
                this.fetchProjects();
            },

            switchDoneProjects() {
                this.showDoneProjects = !this.showDoneProjects;
                this.fetchProjects();
            },

            getInicials(user) { return getInicials(user.name, user.image); },

            getImageOfUser(user) { return user.image ? "/uploads/"+user.image : null; },

            selectProject(project) {
                this.selectedProject = project;
                this.closeModal();
                
                this.$refs.projectNote.focus();
            },

            formatTime(time) { return formatTotal(time); },

            fetchProjects() {
                this.$store.dispatch("fetchMineProjects", {
                    search: this.search,
                    all: this.showAllProjects,
                    done: this.showDoneProjects
                }).then(() => {
                    this.$refs.searchModalInput.focus();
                });
            },

            openModal() {this.show = true },

            saveModal() { this.show = false; },

            closeModal() { this.show = false; },

            switchPositionIn() { this.labelPosition = "focused"; },

            switchPositionOut() {
                if (this.projectNote === null || this.projectNote === "") {
                    this.labelPosition = "";
                }
            }
        },

        beforeDestroy() {
            EventBus.$off("runTimer");
            clearTimeout(this.searchTimer);
            
            if(this.running)
                clearInterval(this.timerInterval)
        }
    }
</script>

<style lang="scss">
.project-lister {
    .avatars {
        & > span:not(:first-child) {
            @apply -ml-2;
        }
    }
}
</style>